import React, { useState } from 'react';
import { useClickOutside, round_to } from '../utils';
import { default as Styles, colors } from '../styles';

const LabelSeries = ({ chart_width, x, y, strokeWidth = 2 }) => {
  const [expanded, set_expanded] = useState(false);
  const ref = useClickOutside(() => (expanded ? set_expanded(!expanded) : {}));
  const axis_width = round_to(chart_width / 4, 0);
  return !expanded ? (
    <div
      style={{
        cursor: 'pointer',
        position: 'absolute',
        top: '10px',
        right: '60px',
        borderRadius: '6px',
        backgroundColor: 'rgba(0,0,0,.03)',
        ...Styles.padded('r'),
        ...Styles.col_center('center'),
      }}
      onClick={() => set_expanded(!expanded)}
    >
      <svg viewBox="-2 2 20 20" width="20" height="20">
        <line
          x1="0"
          y1="0"
          x2="0"
          y2="20"
          stroke={colors.grey}
          strokeWidth={strokeWidth}
        />
        <line
          x1={-strokeWidth / 2}
          y1="20"
          x2="20"
          y2="20"
          stroke={colors.grey}
          strokeWidth={strokeWidth}
        />
      </svg>
    </div>
  ) : (
    <div
      ref={ref}
      aria-hidden="true"
      style={{
        backgroundColor: colors.chart_tips,
        cursor: 'pointer',
        opacity: expanded ? 0.8 : 0,
        pointerEvents: expanded ? 'auto' : 'none',
        ...Styles.padded('l'),
        ...Styles.col_center('center'),
        ...Styles.pinned,
        ...Styles.elevation('max'),
      }}
      onClick={() => set_expanded(!expanded)}
    >
      <svg
        viewBox={`-${strokeWidth} ${strokeWidth} ${axis_width} ${axis_width}`}
        width={axis_width}
        height={axis_width}
      >
        <line
          x1="0"
          y1="0"
          x2="0"
          y2={axis_width}
          stroke={colors.pristine}
          strokeWidth={strokeWidth}
        />
        <line
          x1={-strokeWidth / 2}
          y1={axis_width}
          x2={axis_width}
          y2={axis_width}
          stroke={colors.pristine}
          strokeWidth={strokeWidth}
        />
      </svg>

      <p
        style={{
          ...Styles.uppercase,
          color: colors.pristine,
          position: 'absolute',
          left: '20%',
          bottom: '20px',
        }}
      >
        {x}
      </p>

      <p
        style={{
          ...Styles.uppercase,
          color: colors.pristine,
          transform: 'rotate(-90deg)',
          position: 'absolute',
          left: '20%',
        }}
      >
        {y}
      </p>
    </div>
  );
};
export default LabelSeries;
